/*jshint esversion: 8 */
import { createStore } from 'vuex'
import AppService from "./services/AppService";
import PostSurveyService from "./services/PostSurveyService";
import Utils from "./helpers/utils";
import TranslationService from "./services/TranslationService";
import ConversationService from "./services/ConversationService";
//import { fetch as fetchPolyfill } from "whatwg-fetch";
import $ from "jquery";
import createPersistedState from "vuex-persistedstate";

import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';


let Service = new AppService();
const translationService = new TranslationService();
const conversationService = new ConversationService();

const store = createStore({
  plugins: [createPersistedState({key:'cc_state'})],
  state: {
      initialAppData: {},
      appData: {},
      jsonDataLink: "",
      dataFileUrl: "",
      appHost: "",
      isCaptchaPassed: false,
      conversationData: [],
      chatData: {},
      redDot: false,
      newMessageCome: false,
      agentTypingStatus: 2,
      pollingCounter: 0,
      getEventsGotError: false,
      participantName: "",
      alertsArr: [],
      isShowErrorsView: false,
      errorsDisplayType: "alert",
      errorPage: "",
      expiredPage: "",
      waitingPage: "",
      jsonOOH: "",
      oohData: {},
      parsedWidgetHost: "",
      helperApiAppName: "",
      connIdBeforeDisconnect: null,
      currentView: { viewName: "chat" },
      videoMessage: null,
      agentAutoMessage: null,
      userIP: null,
      referrer: null,
      location: null,
      ccUrl: null,
      CCUServerAddress: "",
      OptionalParameterFromAPI: null,
      OptionalParameterFromAPI_Const: null,
      OptionalParameterFromExternal: [],
      showVideoLoader: false,
      callOnHold: false,
      kioskIsClose: true,
      connectedToCallCenter: false,
      agentArrivedToVideo: false,
      vidyoError: false,
      vidyoRetryAttempts: 0,
      lastResponse: "",
      IISAppName: "PS.CustomChat",
      userTenant: null,
      userTenantID: -1,
      translationSourceLang: null,
      translationSkill: null,
      isTranslationOn: false,
      availabilityChecked: false,
      hideConversation: false,
      isAutoJoin: false,
      scEvents: [],
      scAnswered: false,
      scEventId: 0,
      initialRoute: null,
      passedCallID: null,
      isSurveyOnly: false,
      captchaConfig: {},
      captchaToken: null,
      widgetId: null,
      selectedSkills: [],
      isCallback: false,
      forceCallback: false,
      forceCallbackMessage: null,
      scSentMessage: false,
      scReceivedReplyTyping: false,
  },
  mutations: {
    setIsTranslationOn(state, mode) {
      state.isTranslationOn = mode;
    },
    setTranslationSourceLang(state, lang) {
      state.translationSourceLang = lang;
    },
    setTranslationSkill(state, skill) {
      state.translationSkill = skill;
    },
    setDataFileUrl(state, url) {
      state.dataFileUrl = url;
    },
    setCaptchaPassed(state, flag) {
      state.isCaptchaPassed = flag;
    },
    setAutoJoin(state, flag) {
      state.isAutoJoin = flag;
    },
    setAppData(state, filesArr) {
      //Deep Clone
      let dataJson = Utils.findObJInArrByKeyValue(
        filesArr,
        "fileName",
        "data.json"
      );
      if (dataJson) {
        state.initialAppData = JSON.parse(dataJson.text);
        state.appData = JSON.parse(dataJson.text);
        window.customChatJson = JSON.parse(dataJson.text);

        //dynmically create state.appData.JoinChatData from JoinChatDataDefault
        if (state.appData.JoinChatDataDefault) {
          state.appData.JoinChatData = Object.assign(
            {},
            state.appData.JoinChatDataDefault
          );
        }

        if (state.appData.WidgetData && state.appData.WidgetData.config) {
          let waitingUrl = "waiting.html";
          if (state.appData.WidgetData.config.waitingUrl)
            waitingUrl = state.appData.WidgetData.config.waitingUrl;
          let waitingPage = Utils.findObJInArrByKeyValue(
            filesArr,
            "fileName",
            waitingUrl
          );
          if (waitingPage) {
            state.waitingPage = waitingPage.text;
            Utils.log.debug("Read " + waitingUrl);
          }

          let expiredUrl = "expired.html";
          if (state.appData.WidgetData.config.expiredUrl)
            waitingUrl = state.appData.WidgetData.config.expiredUrl;
          let expiredPage = Utils.findObJInArrByKeyValue(
            filesArr,
            "fileName",
            expiredUrl
          );
          if (expiredPage) {
            state.expiredPage = expiredPage.text;
            Utils.log.debug("Read " + expiredUrl);
          }
        }        
        if (state.appData.WidgetData && state.appData.WidgetData.translationConfig && state.appData.WidgetData.translationConfig.activationState == 'DISABLED')
          state.appData.WidgetData.translationConfig = undefined;
      }
      let errorPage = Utils.findObJInArrByKeyValue(
        filesArr,
        "fileName",
        "errorPage.html"
      );
      if (errorPage) {
        state.errorPage = errorPage.text;
      }
      let jsonOOH = Utils.findObJInArrByKeyValue(
        filesArr,
        "fileName",
        "ooh.json"
      );
      if (jsonOOH) {
        state.jsonOOH = JSON.parse(jsonOOH.text);
      }
      this.commit("setOptionalParameters");
      if (state.initialRoute && state.initialRoute.value !== '')
        Utils.setCurrentRoute(state.initialRoute);
    },
    setOptionalParameters(state) {
      state.OptionalParameterFromAPI = JSON.parse(
        JSON.stringify(state.OptionalParameterFromAPI_Const)
      );
      //Init Optional parameters from API, set special at their place and delete it to prevent duplicate values
      state.appData.JoinChatData.OptionalParameterCount = [];

      if (state.OptionalParameterFromAPI) {
        // set selected OP especially on vars also outside from OptionalParameterCount
        if (state.OptionalParameterFromAPI.call_center_queuename) {
          state.appData.JoinChatData.Call_Center_QueueName =
            state.OptionalParameterFromAPI.call_center_queuename;
          delete state.OptionalParameterFromAPI["call_center_queuename"];
        }
        if (state.OptionalParameterFromAPI.calling_user_hardmessage) {
          state.appData.JoinChatData.Calling_User_HardMessage =
            state.OptionalParameterFromAPI.calling_user_hardmessage;
          delete state.OptionalParameterFromAPI["calling_user_hardmessage"];
        }
        if (state.OptionalParameterFromAPI.applicationid) {
          state.appData.JoinChatData.ApplicationID =
            state.OptionalParameterFromAPI.applicationid;
          delete state.OptionalParameterFromAPI["applicationid"];
        }
        if (state.OptionalParameterFromAPI.calling_user_firstname) {
          state.appData.JoinChatData.Calling_User_FirstName =
            state.OptionalParameterFromAPI.calling_user_firstname;
          delete state.OptionalParameterFromAPI["calling_user_firstname"];
        }
        if (state.OptionalParameterFromAPI.calling_user_lastname) {
          state.appData.JoinChatData.Calling_User_LastName =
            state.OptionalParameterFromAPI.calling_user_lastname;
          delete state.OptionalParameterFromAPI["calling_user_lastname"];
        }
        if (state.OptionalParameterFromAPI.calling_user_skills) {
          state.appData.JoinChatData.Calling_User_Skills =
            state.OptionalParameterFromAPI.calling_user_skills;
          delete state.OptionalParameterFromAPI["calling_user_skills"];
        }

        //if exist other  OP from API, set it inside object which will sent at JoinChat request
        for (var prop in state.OptionalParameterFromAPI) {
          Utils.log.debug(state.OptionalParameterFromAPI[prop]);
          state.appData.JoinChatData.OptionalParameterCount.push({
            key: prop.toUpperCase(),
            value: state.OptionalParameterFromAPI[prop],
          });
        }
      }
    },
    setJoinChat(state, joinChatObjName) {
      if (joinChatObjName) {
        var ns = {};
        try {
          ns = Object.fromEntries(Object.entries(state.appData[joinChatObjName]).map(([k, v]) => [k.replaceAll(' ', '_'), v]));
        } catch(err) {
          Utils.log.info("Failed to set join chat data from " + joinChatObjName, err);
        }
        state.appData.JoinChatData = {
          ...state.appData.JoinChatDataDefault,
          ...ns,
        };
      } else {
        state.appData.JoinChatData = Object.assign(
          {},
          state.appData.JoinChatDataDefault
        );
      }
      Utils.log.debug("state.appData.JoinChatData", state.appData.JoinChatData);
    },
    setParsedWidgetHost(state, hostUrl) {
      state.parsedWidgetHost = hostUrl;
    },
    setParsedSCHAPI(state, schapiAppName) {
      state.helperApiAppName = schapiAppName;
    },
    setWidgetId(state, widgetId) {
      Utils.log.debug("state.widgetId = " + widgetId);
      state.widgetId = widgetId;
    },
    setDataBeforeJoinKiosk(state) {
      //empty last conversation before new one.
      state.conversationData = [];
      state.pollingCounter = 0;
      state.appData.JoinChatData.Calling_User_URL = "CustomChat";

      state.appData.JoinChatData.OptionalParameterCount.push({
        key: "IS_KIOSK_MODE",
        value: true,
      });
    },
    setOPArray(state, fields) {
      //prepare Optional Parameters before send
      let optionalParameterArray = state.appData.JoinChatData.OptionalParameterCount;
      Utils.log.debug(optionalParameterArray.length + " joinchat OPs set");
      //add non-empty fields from the form to "optionalParameterArray"
      if (fields && Array.isArray(fields)) {
        Utils.log.debug(fields.length + " field OPs set");
        fields.forEach((it) => {
          if (it.value !== "" && it["optParamName"]) {
            let tempObj = {};
            // let tempObj = state.appData.OptionalParameter;
            tempObj.key = it["optParamName"].toUpperCase();
            if (typeof it.value === 'boolean')
              tempObj.value = it.value ? "true" : "false";
            else
              tempObj.value = it.value;

            //find if exist this key on optionalParameterArray, is so -> replace it with new one from user input
            let index = optionalParameterArray.findIndex(
              (o) => o.key == it["optParamName"].toUpperCase()
            );
            Utils.log.debug(JSON.stringify(tempObj));
            if (index > -1) {
              optionalParameterArray[index] = tempObj;
            } else {
              optionalParameterArray.push(tempObj);
            }
          }
        });
      }

      if (state.OptionalParameterFromExternal && state.OptionalParameterFromExternal.length > 0) {
        Utils.log.debug(state.OptionalParameterFromExternal.length + " external OPs to set");
        state.OptionalParameterFromExternal.forEach((op) => {
          try {
            Utils.log.debug(JSON.stringify(op));
            if (op && op.optParamName && op.value) {
              state.appData.JoinChatData.OptionalParameterCount.push({
                key: op.optParamName,
                value: op.value,
              });
            }
          } catch (err) {
            Utils.log.Info("Error stringifying external OP", err);
          }
        });
      }

      optionalParameterArray.push({ key: "SC_IP", value: state.userIP });
      if (state.referrer)
        optionalParameterArray.push({ key: "SC_REFERRER", value: state.referrer });
      if (state.ccUrl)
        optionalParameterArray.push({ key: "SC_CC_URL", value: state.ccUrl });
      if (state.location)
        optionalParameterArray.push({ key: "SC_LOCATION", value: state.location });
      if (state.translationSourceLang) {
        optionalParameterArray.push({ key: "SC_TRSRCLANG", value: state.translationSourceLang.toUpperCase() });
      }
      if (state.appData.WidgetData.translationConfig && state.appData.WidgetData.translationConfig.targetLanguage) {
        optionalParameterArray.push({ key: "SC_TRDESTLANG", value: state.appData.WidgetData.translationConfig.targetLanguage.toUpperCase() });
      }
      if (state.translationSkill) {
        optionalParameterArray.push({ key: "SC_TRSKILL", value: state.translationSkill });
      }

      //add "QueryOptionalParameters" fields to "optionalParameterArray"
      if (Object.keys(state.appData.QueryOptionalParameters).length !== 0) {
        Utils.log.debug(state.appData.QueryOptionalParameters.length + " query OPs to set");
        state.appData.QueryOptionalParameters.forEach((op) => {
          Utils.log.debug(JSON.stringify(op));
          optionalParameterArray.push(op);
        });
      }      
    },
    setDataBeforeCallback(state, data) {
      this.commit("setOptionalParameters");
      state.conversationData = [];
      
      state.appData.CallbackData = {};
      state.appData.CallbackData.QueueID = 0;
      state.appData.CallbackData.From = "";
      state.appData.CallbackData.TenantID = state.userTenantID;
      state.appData.CallbackData.CallbackNumber = data.strCallbackNumber;
      if (data.strFirstName) {
        state.appData.CallbackData.From = data.strFirstName;
      }
      if (data.strLastName) {
        state.appData.CallbackData.From = (state.appData.CallbackData.From + " " + data.strLastName).trim();
      }
      if (data.strUserSubject) {
        state.appData.CallbackData.Subject = data.strUserSubject;
      }      
      if (state.appData.JoinChatData.CallbackGroupID) {
        state.appData.CallbackData.GroupID = state.appData.JoinChatData.CallbackGroupID;
      }
      if (state.appData.JoinChatData.CallbackImmediateDialing) {
        state.appData.CallbackData.ImmediateDialing = state.appData.JoinChatData.CallbackImmediateDialing;
      }

      state.appData.CallbackData.QueueName = state.appData.JoinChatData.Call_Center_QueueName;
      if (data.skills && data.skills.length>0) {
        if (!state.appData.JoinChatData.Calling_User_Skills || state.appData.JoinChatData.Calling_User_Skills == '')
          state.appData.CallbackData.Skills = data.skills;
        else
          state.appData.CallbackData.Skills = state.appData.JoinChatData.Calling_User_Skills + "," + data.skills;
          Utils.log.debug("User selected skills, skill-routing:" + state.appData.CallbackData.Skills);
      }
      else {
        state.appData.CallbackData.Skills = state.appData.JoinChatData.Calling_User_Skills;
        Utils.log.debug("No user selected skills, skill-routing:" + state.appData.CallbackData.Skills);
      }
      this.commit("setOPArray", data.fields);
      state.appData.CallbackData.Options = [];
      state.appData.JoinChatData.OptionalParameterCount.forEach((op) => {
        if (op && op.key && op.value)
          state.appData.CallbackData.Options.push(op.key.replace(':','') + ":" + op.value.replace(':',''));
      });

    },
    setDataBeforeJoinChat(state, data) {
      // state.appData.JoinChatData.OptionalParameterCount = [] TODO: check if this is the fix
      //TODO: see if "setOptionalParameters" here needed - see that no needed
      this.commit("setOptionalParameters");
      //empty last conversation before new one.
      state.conversationData = [];
      state.pollingCounter = 0;
      if (data.strFirstName) {
        state.appData.JoinChatData.Calling_User_FirstName = data.strFirstName;
      }
      if (data.strLastName) {
        state.appData.JoinChatData.Calling_User_LastName = data.strLastName;
      }
      if (data.strUserSubject) {
        state.appData.JoinChatData.Calling_User_HardMessage =
          data.strUserSubject;
      }
      state.appData.JoinChatData.Calling_User_URL = "CustomChat";
      if (state.userTenant) state.appData.JoinChatData.TenantID = state.userTenant;

      if (data.skills && data.skills.length>0) {
        if (!state.appData.JoinChatData.Calling_User_Skills || state.appData.JoinChatData.Calling_User_Skills == '')
          state.appData.JoinChatData.Calling_User_Skills = data.skills;
        else
          state.appData.JoinChatData.Calling_User_Skills += "+" + data.skills;
          Utils.log.debug("User selected skills, skill-routing:" + state.appData.JoinChatData.Calling_User_Skills);
      }
      else
        Utils.log.debug("No user selected skills, skill-routing:" + state.appData.JoinChatData.Calling_User_Skills);

        this.commit("setOPArray", data.fields);
    },
    setDataBeforeSendMessage(state, strText) {
      state.appData.SendMessageData.Connection_ID =
        state.appData.DataGlobal.connId;
      state.appData.SendMessageData.Message_Text = strText;
    },
    setDataBeforeSendTyping(state, nTypingStatus) {
      state.appData.TypingMessageData.Connection_ID =
        state.appData.DataGlobal.connId;
      state.appData.TypingMessageData.typing_status = nTypingStatus;
    },
    setDataBeforeLeaveChat(state) {
      state.appData.LeaveChatData.Connection_ID =
        state.appData.DataGlobal.connId;
    },
    setConnId(state, status) {
      if (!state || !state.appData || !state.appData.DataGlobal)
        return;
      Utils.log.debug("Setting connection ID :" + status);
      if (state.appData.DataGlobal.connId !== -1) {
        state.connIdBeforeDisconnect = state.appData.DataGlobal.connId;
      } else {
        localStorage.removeItem("cc_lastWrite");
        localStorage.removeItem("cc_sessionId");
      }
      state.appData.DataGlobal.connId = status;
    },
    setRedDot(state, flag) {
      state.redDot = flag;
    },
    setNewMessageCome(state, flag) {
      state.newMessageCome = flag;
    },
    setParticipantName(state, participantName) {
      if (!participantName) participantName = "";
      Utils.log.debug("Setting participant name:" + participantName);
      state.participantName = participantName;
    },
    setAgentTyping(state, typingStatus) {
      state.agentTypingStatus = typingStatus;
    },
    setLastEventId(state, id) {
      Utils.log.debug("Setting last event ID:" + id);
      state.appData.DataGlobal.lastEventId = id;
    },
    initChatAndVideo(state) {
      Utils.log.debug("initChatAndVideo");
      //deep clone
      state.appData = JSON.parse(JSON.stringify(state.initialAppData));
      //dynmically create state.appData.JoinChatData from JoinChatDataDefault
      if (state.appData.JoinChatDataDefault) {
        state.appData.JoinChatData = Object.assign(
          {},
          state.appData.JoinChatDataDefault
        );
      }
      //now, after joinChat initilize, setOptionalParameters which we got from URL when app loaded
      this.commit("setOptionalParameters");
      this.commit("setConnectedToCallCenter", false);
      this.commit("setVideoMessage", null);
      this.commit("removeAlertFromArray");
      state.participantName = "";

      state.chatData = {};
      state.pollingCounter = 0;
      state.isCaptchaPassed = false;
      state.getEventsGotError = false;
      state.translationSourceLang = null;
      state.translationSkill = null;

      state.scEvents = [];
      state.scAnswered = false;
      state.scEventId = 0;
      state.captchaToken = null;
    },
    increaseDecreasePolling(state, isIncrease) {
      isIncrease ? state.pollingCounter++ : (state.pollingCounter = 0);
    },
    setCurrentPolling(state, currentPolling) {
      state.pollingCounter = currentPolling;
    },
    setErrorResponseFromGetEvents(state, flag) {
      state.getEventsGotError = flag;
    },
    joinChatSuccess(state, data) {
      state.appData.DataGlobal.connId = data.res.Connection_ID;
      state.appData.DataGlobal.lastEventId = 0;

      //The name and gravatar, is for sending New Chat Message
      state.chatData = { ...state.chatData, name: data.userName };
      state.chatData = { ...state.chatData, gravatar: data.res.Connection_ID };
    },
    addChatLine(state, line) {
      // All times are displayed in the user's timezone
      let d = new Date();
      if (line.time) {
        // PHP returns the time in UTC (GMT). We use it to feed the date
        // object and later output it in the user's timezone. JavaScript
        // internally converts it for us.
        d.setUTCHours(line.time.hours, line.time.minutes);
      }
      line.time = d.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      });
      this.commit('checkTranslation', line);
      state.conversationData.push(line);
    },
    checkTranslation(state, line) {
      if (line.author_type && line.author_type !== "me") {
        let splittedTrArr = line.text.split(this.getters.msgTrDelimeter);
        //if translated msg
        if (splittedTrArr.length >= 2) {
          if (state.isTranslationOn) {
            line["text"] = splittedTrArr[1];
          }
          else {
            line["text"] = splittedTrArr[0];
          }
          //line["translatedText"] = splittedTrArr[0];
        }

      }
    },
    resetConversationData(state) {
      state.conversationData = [];
    },
    setAlertData(state, data) {
      state.alertData.text = data.text;
      state.alertData.type = data.type;
    },
    setOohData(state, data) {
      state.oohData = data;
      if ((data.is_open != true) && (state.appData.WidgetData.config.externalController == true))
        window.parent.postMessage({ CC: { "ooh": data.message } }, "*");
      if (data)
        Utils.log.debug("OOH data: " + JSON.stringify(data));  
    },
    setCallId(state, callId) {
      Utils.log.debug("Setting call ID:" + callId);
      state.chatData.callId = callId;
    },
    setCurrentView(state, viewName) {
      Utils.log.debug("Setting current view:" + viewName);
      state.currentView = { ...state.currentView, viewName: viewName };
    },
    setVideoMessage(state, msg) {
      Utils.log.debug("Setting video message:" + msg);
      state.videoMessage = msg;
    },
    setAgentAutoMessage(state, text) {
      state.agentAutoMessage = text;
    },
    setUserIP(state, IP) {
      Utils.log.debug("setUserIP", IP);
      state.userIP = IP;
    },
    setReferrer(state, referrer) {
      if (state.referrer) return; // Only want original referrer
      Utils.log.debug("setReferrer", referrer);
      state.referrer = referrer;
    },
    setCCUrl(state, ccUrl) {
      if (state.ccUrl) return; // Only want original CC URL
      Utils.log.debug("setCCUrl", ccUrl);
      state.ccUrl = ccUrl;
    },
    setLocation(state, location) {
      Utils.log.debug("setLocation", location);
      state.location = location;
    },
    setUserTenant(state, Tenant) {
      Utils.log.debug("setUserTenant", Tenant);
      state.userTenant = Tenant;
    },
    setUserTenantID(state, TenantID) {
      Utils.log.debug("setUserTenantID", TenantID);
      state.userTenantID = TenantID;
    },
    setCCUServerAddress(state, server) {
      Utils.log.debug("setCCUServerAddress", server);
      state.CCUServerAddress = server;
    },
    setOptionalPatametersFromAPI(state, OPObj) {
      // state.OptionalParameterFromAPI = OPObj;
      state.OptionalParameterFromAPI_Const = OPObj;
    },
    setOptionalParameterFromExternal(state, OPObj) {
      state.OptionalParameterFromExternal = OPObj;
    },
    setVideoLoader(state, flag) {
      state.showVideoLoader = flag;
    },
    setCallOnHold(state, flag) {
      state.callOnHold = flag;
    },
    setKioskIsClose(state, flag) {
      state.kioskIsClose = flag;
    },
    setConnectedToCallCenter(state, flag) {
      state.connectedToCallCenter = flag;
    },
    setAgentArrivedToVideo(state, flag) {
      state.agentArrivedToVideo = flag;
    },
    setVidyoError(state, flag) {
      state.vidyoError = flag;
    },
    setLastResponse(state, response) {
      state.lastResponse = response;
    },
    addAlertToArray(state, alert) {
      if (state.appData.WidgetData.config.externalController == true)
        window.parent.postMessage({ CC: { "systemMessage": alert } }, "*");
      if (
        state.appData.WidgetData.config.errorsDisplayType === "view" &&
        alert.type == "error"
      ) {
        state.isShowErrorsView = true;
      }
      else if (
        state.appData.WidgetData.config.errorsDisplayType === "toast"
      ) {
        try {
          var cl = alert.text.split(' ')[0]
          ? alert.text.split(' ')[0].toUpperCase()
          : '_' + '_' + alert.text.split(' ')[1]
          ? alert.text.split(' ')[1].toUpperCase()
          : '_' + '_' + alert.text.split(' ')[2]
          ? alert.text.split(' ')[2].toUpperCase()
          : '_' + '_ALERT';
          if (alert.type == "error")
            toast.error(alert.text, {"bodyClassName":cl, "autoClose":false});
          else if (alert.type == "info")
            toast.info(alert.text, {"bodyClassName":cl});
          else
            Utils.log.debug("Ignoring alert type for toast:" + alert.type);
        }
        catch(err) {
          Utils.log.info("Error displaying alert:" + alert.text, err);
        }
        return;
      }

      state.alertsArr.push(alert);
      if (alert.timeout && alert.id) {
        setTimeout(() => {
          this.commit("removeAlertFromArray", alert.id);
        }, alert.timeout);
      }
    },
    removeAlertFromArray(state, alertId) {
      if (alertId) {
        const index = state.alertsArr.findIndex((it) => it.id == alertId);
        if (index > -1) {
          state.alertsArr.splice(index, 1);
        }
      } else {
        state.alertsArr = [];
      }
    },
    setParsedIISAppName(state, IISAppName) {
      state.IISAppName = IISAppName;
    },
    setAvailabilityChecked(state, flag) {
      state.availabilityChecked = flag;
    },
    setHideConversation(state, flag) {
      state.hideConversation = flag;
    },
    addSCEvent(state, event) {
      event.Event_ID = ++state.scEventId;
      state.scEvents.push(event);
    },
    setInitialRoute(state, route) {
      state.initialRoute = route;
      state.isSurveyOnly = route == 'PostSurveyView';
    },
    setPassedCallID(state, callID) {
      state.passedCallID = callID;
    },
    resetSCEvents(state) {
      state.scEvents = [];
    },
    resetSCEventId(state) {
      state.scEventId = 0;
    },
    setSCAnswered(state, answered) {
      state.scAnswered = answered;
    },
    setCaptchaConfig(state, captchaConfig) {
      state.captchaConfig = {};
      try {
        if (captchaConfig && captchaConfig != '')
          state.captchaConfig = JSON.parse(captchaConfig);
      } catch (err) {
        Utils.log.debug("Error parsing CaptchaConfig:" + captchaConfig, err);
      }
    },
    setCaptchaToken(state, captchaToken) {
      state.captchaToken = captchaToken;
    },
    setForceCallback(state, forced) {
      Utils.log.debug("ForceCallback: " + JSON.stringify(forced));
      state.forceCallback = forced.forced;
      state.forceCallbackMessage = forced.message;
    },
    setSCSentMessage(state, flag) {
      state.scSentMessage = flag;
    },
    setSCReceivedReplyTyping(state, flag) {
      Utils.log.debug("scReceivedReplyTyping: " + flag);
      state.scReceivedReplyTyping = flag;
    },
  },
  actions: {
    async getTranslatedText(context, data) {
      Utils.log.debug("on store getTranslatedText ");
      try {
        let res = await translationService.getTranslation(data.url);
        return res;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getTextLanguage(context, data) {
      try {
        let res = await translationService.getTextLanguage(data.url);
        return res;
      } catch (error) {
        throw new Error(error);
      }
    },
    async getAppData(context) {
      try {
        let res = await Service.getAppData(context.state.dataFileUrl);
        if(!sessionStorage.getItem("cc_resumed"))
          context.commit("setAppData", res);
        localStorage.setItem("cc_zipLoaded", context.state.dataFileUrl);
        return res;
      } catch (e) {
        throw e;
      }
    },
    async callback(context) {
      try {
        context.state.isCallback = true;
        let res = await Service.joinChat(
          context.state.appData.DataGlobal.callbackSDK,
          context.state.appData.CallbackData
        );
        Utils.log.debug("callback: " + JSON.stringify(res));
        return res;
      } catch (e) {
        Utils.log.error(e.message);
        if (context.state.appData.WidgetData.config.externalController == true) {
          var errCode = null;
          if (e.Error_Code) errCode = 'Error Code: ' + e.Error_Code;
          window.parent.postMessage({ CC: { "joinFailed": e.message || e.name || errCode || 'Failed' } }, "*");
        }
        throw e;
      }
    },
    async joinChat(context) {
      context.state.isCallback = false;
      if (context.getters.isSCOverride) {
        try {
          Utils.log.debug("joinChat SC entered");
          if (context.state.scConnection) context.state.scConnection.stop();
          var fName = context.state.appData.JoinChatData.Calling_User_FirstName;
          var lName = context.state.appData.JoinChatData.Calling_User_LastName;
          var conn = $.hubConnection(context.state.appData.SCOverride.Url);
          conn.logging = true;
          conn.qs = {"ID":(fName + ' ' + lName).trim(), "ChatID": context.state.appData.SCOverride.SCName, "SubChannel": "CustomChat"};
          if (context.state.appData.JoinChatData.OptionalParameterCount && context.state.appData.JoinChatData.OptionalParameterCount.length > 0) {
            context.state.appData.JoinChatData.OptionalParameterCount.forEach((kvp) => {
              if (kvp.key && kvp.value && kvp.key != "ID" && kvp.key != "ChatID" && kvp.key != "SubChannel" && kvp.value != "")
                conn.qs[kvp.key] = kvp.value;
            });
          }
          if (context.state.appData.JoinChatData.OptionalParameterCount && context.state.appData.JoinChatData.OptionalParameterCount.length > 0)
            context.state.appData.JoinChatData.OptionalParameterCount.forEach((kvp) => {
              if (kvp.key && kvp.value && (kvp.key instanceof String) && !kvp.key.includes("[") && !(kvp.value instanceof Object))
              conn.qs[kvp.key] = kvp.value;
            });
          const proxy = conn.createHubProxy('TesterChatHub');
          Utils.setSCConnection(conn);
          Utils.setSCProxy(proxy);
          this.commit("resetSCEvents");
          this.commit("setSCAnswered", false);
          this.commit("setSCSentMessage", false);
          this.commit("setSCReceivedReplyTyping", false);
          let that = this;

          conn.starting(function(e, data) {
            Utils.log.debug("SC connection starting", data);
          });
          conn.received(function(e, data) {
            Utils.log.debug("SC connection received", data);
          });
          conn.connectionSlow(function(e, data) {
            Utils.log.warn("SC connection slow", data);
          });
          conn.reconnecting(function(e, data) {
            Utils.log.warn("SC connection reconnecting", data);
          });
          conn.reconnected(function(e, data) {
            Utils.log.warn("SC connection reconnected", data);
          });
          conn.stateChanged(function(e, data) {
            Utils.log.debug("SC connection received", data);
          });
          conn.disconnected(function() {
            Utils.log.debug("SC connection Disconnected");
            if (context.state.scAnswered == true) {
              that.commit("addSCEvent", {"Command":"ParticipantDisconnected", "Connection_ID": conn.id});
              that.commit("addSCEvent", {"Command":"status", "Status_Code": 107, "Connection_ID": conn.id});
              that.commit("setSCAnswered", false);
            }
            if (context.state.scConnection) context.state.scConnection.stop();
            Utils.setSCConnection(null);
            Utils.setSCProxy(null);
            });
          proxy.on("Error", function(error) {
            Utils.log.error(error);
          });
          proxy.on("ReceiveMessage", function(message) {
            Utils.log.debug("SC proxy ReceiveMessage", message);
            if (!context.getters.scAnswered) {
              Utils.log.debug("SC proxy setting SC answered");
              that.commit("setSCAnswered", true);
              that.commit("addSCEvent", {"Command":"status", "Status_Code": 106, "Call_Id": "" + (context.state.passedCallID ? context.state.passedCallID : Date.now()), "Connection_ID": conn.id});
            }
            that.commit("addSCEvent", {"Command":"read", "Message_Text": message, "Connection_ID": conn.id});
          });
          proxy.on("ReceiveStatus", function(status) {
            Utils.log.debug("SC proxy ReceiveStatus", status);
            if (status == 'scconnected') {
              if (!context.getters.scAnswered) {
                Utils.log.debug("SC proxy setting SC answered");
                that.commit("setSCAnswered", true);
                that.commit("addSCEvent", {"Command":"status", "Status_Code": 106, "Call_Id": "" + (context.state.passedCallID ? context.state.passedCallID : Date.now()), "Connection_ID": conn.id});
              }
            }
            else if (status.startsWith('convid:')) {
              var convID = status.substring(status.indexOf(':')+1);
              Utils.log.debug("SC proxy setting SC conv ID " + convID);
              that.commit("setPassedCallID", convID);
              proxy.invoke("Status", status ); // Echo back so SC knows it has been set
            }
            else {              
              //that.commit("addSCEvent", {"Command":"read", "Message_Text": status});
              try {
                let statusT = context.state.appData.StatusRes[status];
                if (statusT)
                  conversationService.addSystemMessage(statusT.messageForUser);
                else if (isNaN(status) && context.state.appData.SCOverride.SummaryIncludesTextStatuses)
                  conversationService.addSystemMessage(status);
              } catch (err) {}
            }
          });
          proxy.on("Typing", function(typing) {
            Utils.log.debug("SC proxy Typing", typing);
            that.commit("addSCEvent", {"Command":"typingStatus", "Message_Text": typing ? "1" : "2", "Connection_ID": conn.id});
            if (typing && context.state.scSentMessage) that.commit("setSCReceivedReplyTyping", true);
          });
          proxy.on("Disconnected", function() {
            Utils.log.debug("SC proxy Disconnected");
            if (context.state.scAnswered == true) {
              that.commit("addSCEvent", {"Command":"ParticipantDisconnected", "Connection_ID": conn.id});
              that.commit("addSCEvent", {"Command":"status", "Status_Code": 107, "Connection_ID": conn.id});
              context.commit("setSCAnswered", false);
            }
            if (context.state.scConnection) context.state.scConnection.stop();
            context.commit("setSCConnection", null);
            context.commit("setSCProxy", null);
            conn.stop();          
          });
          Utils.log.debug("joinChat SC starting connection");
          await conn.start().done(() => {
            Utils.log.debug(`joinChat SC started connection ${conn.id}`);
            that.commit("resetSCEventId");
            that.commit("addSCEvent", {"Command":"status", "Status_Code": 104, "Connection_ID": conn.id});
            that.commit("addSCEvent", {"Command":"status", "Status_Code": 165, "Connection_ID": conn.id});
          }).fail((error) => {
            Utils.log.error("joinChat SC failed connection", error);
            that.commit("addSCEvent", {"Command":"Error", "Status_Code": 6, "statusText": error.message ? error.message : "" + error});
          });
          Utils.log.debug("joinChat SC exiting");
          return {"Available-Connections": 999, "Connection_ID": conn.id};
        }
        catch (e) {
          Utils.log.error(e.message);
          if (context.state.appData.WidgetData.config.externalController == true) {
            var errCode = null;
            if (e.Error_Code) errCode = 'Error Code: ' + e.Error_Code;
            window.parent.postMessage({ CC: { "joinFailed": e.message || e.name || errCode || 'Failed' } }, "*");
          }
          throw e;
        }
      }
      let arrayLength =
        context.state.appData.DataGlobal.CCUServerAddress.length;
      let randIndex = Math.floor(Math.random() * arrayLength);
      let i = randIndex;

      //set roundRobin
      while (true) {
        let server = context.state.appData.DataGlobal.CCUServerAddress[i];        
        let url = `${server}/scripts/ChatExtension.DLL?joinchat`;
        var data = context.state.appData.JoinChatData;
        var scJC = false;
        if (context.state.helperApiAppName && context.state.helperApiAppName!='' && context.state.widgetId && context.state.widgetId !='') {
          Utils.log.debug("joinChat using SC Helper");
          data.token = context.state.captchaToken;
          data.contactCentres = context.state.appData.DataGlobal.CCUServerAddress;
          url = `https://${context.getters.getWidgetHost}/${context.state.helperApiAppName}/api/customchat/joinChat?WidgetId=${context.state.widgetId}`;
          scJC = true;
        }
        else {
          Utils.log.debug("joinChat using direct CCUServerAddress " + server);          
        }
        try {
          let res = await Service.joinChat(
            url,
            data
          );
          Utils.log.debug("joinChat: " + JSON.stringify(res));
          if (res === undefined || (res && res.Error_Code && (res.Error_Code == 18 || res.Error_Code == 12))) {
            i++;
            if (scJC || i == randIndex) {
              console.error(res);
              throw res;
            }
            if (i == arrayLength) {
              i = 0;
              if (i == randIndex) {
                console.error(res);
                throw res;
              }
            }
            continue;
          }
          if (!scJC)
            context.commit("setCCUServerAddress", server); // SC will return this in the header which is recorded when received
          return res;
        } catch (e) {
          Utils.log.error(e.message);
          if (context.state.appData.WidgetData.config.externalController == true) {
            var errCode = null;
            if (e.Error_Code) errCode = 'Error Code: ' + e.Error_Code;
            window.parent.postMessage({ CC: { "joinFailed": e.message || e.name || errCode || 'Failed' } }, "*");
          }
          throw e;
        }
      }
    },
    async sendMessage(context) {
      if (context.getters.isSCOverride) {
        try {
          Utils.log.debug("sendMessage SC entered");
          var fName = context.state.appData.JoinChatData.Calling_User_FirstName;
          var lName = context.state.appData.JoinChatData.Calling_User_LastName;
          var name = (fName + ' ' + lName).trim();
          var proxy = Utils.getSCProxy();
          if (proxy) proxy.invoke("BroadCastMessage", name, context.state.appData.SendMessageData.Message_Text );
          this.commit("setSCSentMessage", true);
          if (context.state.appData.WidgetData.config.externalController == true)
            window.parent.postMessage({ CC: JSON.parse(JSON.stringify(context.state.appData.SendMessageData)) }, "*");
          Utils.log.debug("sendMessage SC exiting");
          return {};
        } catch (e) {
          Utils.log.error(e.message);
          throw e;
        }
      }
      let url = `${context.state.CCUServerAddress}/scripts/ChatExtension.DLL?sendmsg`;
      Utils.log.debug("sendMessage via " + url);
      try {
        let res = await Service.sendMessage(
          url,
          context.state.appData.SendMessageData
        );
        Utils.log.debug(`sendMessage via ${context.state.CCUServerAddress}: ${JSON.stringify(res)}`);
        if (res && context.state.appData.WidgetData.config.externalController == true)
          window.parent.postMessage({ CC: JSON.parse(JSON.stringify(context.state.appData.SendMessageData)) }, "*");
        return res;
      } catch (e) {
        Utils.log.error(e.message);
        throw e;
      }
    },
    async getEvents(context) {
      if (context.getters.isSCOverride) {
        var events = [...context.getters.scEvents];
        this.commit("resetSCEvents");
        var ret = {"Events": events};
        if (events && events.length>0 && context.state.appData.WidgetData.config.externalController == true)
          window.parent.postMessage({ CC: JSON.parse(JSON.stringify(ret)) }, "*");
        return ret;
      }    
      if (context.getters.isConnect == false) {
        Utils.log.info("store: Not make getEvent ajax, because not connected");
        return;
      }
      try {
        var curSession = localStorage.getItem("cc_sessionId");
        var mySession = sessionStorage.getItem("cc_sessionId");
        if (curSession && curSession != mySession && !context.getters.isSCOverride) {
          Utils.log.warn("getEvents another session has taken control " + curSession + " vs " + mySession);  
          return;
        }
        let url = `${context.state.CCUServerAddress}/scripts/ChatExtension.DLL?command=getevents&Connection_ID=${context.state.appData.DataGlobal.connId}&Last_Event_ID=${context.state.appData.DataGlobal.lastEventId}`;
        let res = await Service.getEvents(url);
        Utils.log.debug("getEvents: " + JSON.stringify(res));
        if (res && context.state.appData.WidgetData.config.externalController == true)
          window.parent.postMessage({ CC: JSON.parse(JSON.stringify(res)) }, "*");
        localStorage.setItem("cc_lastWrite", new Date());
        localStorage.setItem("cc_sessionId", mySession);
        return res;
      } catch (e) {
        Utils.log.error(e);
        throw e;
      }
    },
    async uploadFile(context, fd) {
      try {
        var host;
        if (context.state.dataFileUrl && context.state.dataFileUrl != '') {
          try {
            var dfurl = new URL(context.state.dataFileUrl);
            if (dfurl.protocol && dfurl.hostname && dfurl.pathname) {
              host = dfurl.protocol + '//' + dfurl.hostname + '/' + dfurl.pathname.split('/')[1];
            }
          } catch (err) {
            Utils.log.info("Error extracting helper API from dataFile Url:" + err.message);
          }
        }
        if (!host) {
          host = context.state.CCUServerAddress + '/' + context.state.helperApiAppName;
          Utils.log.debug("CCU host for upload:" + host);
        }
        else {
          Utils.log.debug("DataFileURL host for upload:" + host);
        }
        let url = host + '/api/helper/saveFile';
        let data = Service.uploadFile(
          url,
          fd,
          context.state.appData.WidgetData.config.uploadFileToken
        );
        return data;
      } catch (e) {
        Utils.log.error(e);
        throw e;
      }
    },
    async setTypingStatus(context, nTypingStatus) {
      if (!context.getters.isConnect) return false;
      context.commit("setDataBeforeSendTyping", nTypingStatus);
      if (context.getters.isSCOverride) {
        var proxy = Utils.getSCProxy();
        if (proxy) proxy.invoke("TypingIndicator", nTypingStatus == 1);
        return;
      }
      let url = `${context.state.CCUServerAddress}/scripts/ChatExtension.DLL?typingmsg`;
      try {
        let data = Service.setTypingStatus(
          url,
          context.state.appData.TypingMessageData
        );
        return data;
      } catch (e) {
        Utils.log.error(e.message);
        throw e;
      }
    },
    leaveChat(context, paramsObj) {
      Utils.log.debug("On leave chat..", JSON.stringify(paramsObj));
      sessionStorage.removeItem("cc_resumed");
      if (!context.getters.isConnect) return false;
      if (context.getters.isSCOverride){
        Utils.log.debug("exiting SC chat");
        if (context.state.scConnection) {
          if (context.state.scAnswered == true)
            context.commit("addSCEvent", {"Command":"status", "Status_Code": 107, "Connection_ID": context.state.scConnection.connectionId});
          context.commit("setConnId", -1);
          context.commit("setSCAnswered", false);
          context.state.scConnection.stop();
          Utils.setSCConnection(null);
          Utils.setSCProxy(null);
      }
        if (context.state.appData.WidgetData.config.externalController == true)
          window.parent.postMessage({ CC: { "leaveChat": true } }, "*");
        Utils.log.debug("exited SC chat");
        return {};
      }
      context.commit("setDataBeforeLeaveChat");
      let url = `${context.state.CCUServerAddress}/scripts/ChatExtension.DLL?leavechat`;
      let res = Service.leaveChat(
        url,
        context.state.appData.LeaveChatData,
        paramsObj,
        () => {
          //onSuccess - normally disconnect
          context.commit("setConnId", -1);
          if (res && context.state.appData.WidgetData.config.externalController == true)
            window.parent.postMessage({ CC: { "leaveChat": true } }, "*");
          localStorage.removeItem("cc_lastWrite");
          localStorage.removeItem("cc_sessionId");
    
        }
      );
      Utils.log.debug("leavechat: " + JSON.stringify(res));
      return res;
    },
    async sendPostSurvey(context, qnasArr) {
      let postSurveyService = new PostSurveyService();
      let url = context.state.appData.WidgetData.config.postSurveySubmitUrl;
      try {
        var tenant = context.state.userTenantID;
        if (!tenant) tenant = context.state.appData.WidgetData.config.postSurveyTenantId;
        var cid = context.state.passedCallID && context.state.passedCallID.startsWith('0x') ? context.state.passedCallID : (context.state.chatData.callId ? "" + context.state.chatData.callId : null);
        var scid = context.state.passedCallID && !context.state.passedCallID.startsWith('0x') ? context.state.passedCallID : null;
        await postSurveyService.sendPostSurvey(
          qnasArr,
          url,
          "Chat",
          context.getters.isSCOverride ? null : cid,
          context.state.appData.WidgetData.config.surveyId,
          tenant,
          context.getters.isSCOverride ? scid : null
        );
      } catch (e) {
        throw e;
      }
    },
    async isAgentAvailable(context, queueOverride) {
      // Any issues getting status assume agent is available
      if (!context.getters.isAgentAvailableCheckingConfigured)
        return true;
      var queue = context.state.appData.JoinChatData.Call_Center_QueueName;
      if (queueOverride)
        queue = queueOverride;
      let url = `${context.state.appData.WidgetData.queueChecks.url}/isQueueStaffed?tenantName=${context.state.appData.JoinChatDataDefault.TenantID}&queueName=${queue}`;
      Utils.log.debug('Checking agent availability:' + url);
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: 'application/json',
          }
        });
        if (response.status != 200) {
          Utils.log.info('Checking agent availability returned error code:' + response.status);
          return true;
        }
        const json = await response.json();
        Utils.log.debug('Checking agent availability returned:' + json.result);
        return json.result;
      } catch (e) {
        Utils.log.error(e.message);
      }
      return true;
    },
  },
  getters: {
    isConnect: (state) => {
      return state.appData.DataGlobal
        ? state.appData.DataGlobal.connId &&
        state.appData.DataGlobal.connId !== -1
        : false;
    },
    isAgentRespond: (state) => (state.participantName !== "") || (state.appData && state.appData.SCOverride && state.scReceivedReplyTyping),
    conversationData: (state) => state.conversationData,
    appData: (state) => state.appData,
    chatData: (state) => state.chatData,
    widgetData: (state) => state.appData.WidgetData,
    redDot: (state) => state.redDot,
    agentTypingStatus: (state) => state.agentTypingStatus,
    getLastResponse(state) {
      try {
        return JSON.parse(state.lastResponse);
      } catch (err) {}
      return undefined;
    },
    participantName: (state) => {
      if (
        state.appData &&
        state.appData.WidgetData &&
        state.appData.WidgetData.config
      )
        switch (state.appData.WidgetData.config.agentNameFormat) {
          case 0: {
            //full name
            return state.participantName;
          }
          case 1: {
            //display initials
            if (state.participantName === "") {
              return state.appData.WidgetData.config.defaultAgentName;
            }
            return state.participantName
              .split(" ")
              .map((n) => n[0])
              .join(".");
          }
          case 2: {
            //omit name
            return state.appData.WidgetData.config.defaultAgentName;
          }
          case 3: {
            //first name
            if (state.participantName === "") {
              return state.appData.WidgetData.config.defaultAgentName;
            }
            return state.participantName.split(" ")[0];
          }
          case 4: {
            //first name and last initial
            if (state.participantName === "") {
              return state.appData.WidgetData.config.defaultAgentName;
            }
            var names = state.participantName.split(" ");
            var ret = names[0];
            if (names.length > 1)
              ret += ". " + names[names.length - 1].substr(0, 1);
            return ret;
          }
          case 5: {
            //first initial and last name
            if (state.participantName === "") {
              return state.appData.WidgetData.config.defaultAgentName;
            }
            var names = state.participantName.split(" ");
            var ret = names[0].substr(0, 1);
            if (names.length > 1) ret += " " + names[names.length - 1];
            return ret;
          }
        }
      return state.participantName;
    },
    pollingCounter: (state) => state.pollingCounter,
    oohShowOptions: (state) => state.appData.WidgetData.config.oohShowOptions,
    oohData: (state) => state.oohData,
    alertData: (state) => state.alertData,
    isCaptchaPassed: (state) => state.isCaptchaPassed,

    mainView: (state) =>
      state.appData.WidgetData.mainView
        ? state.appData.WidgetData.mainView
        : {},
    enterChatView: (state) => state.appData.WidgetData.enterChatView,
    conversationView: (state) => state.appData.WidgetData.conversationView,
    errorsView: (state) => state.appData.WidgetData.errorsView,
    afterChatView: (state) => state.appData.WidgetData.afterChatView,
    postSurveyView: (state) => state.appData.WidgetData.postSurveyView,
    videoView: (state) => state.appData.WidgetData.videoView,
    kioskView: (state) => state.appData.WidgetData.kioskView,
    videoConfig: (state) => state.appData.WidgetData.videoConfig,
    translationConfig: (state) => state.appData.WidgetData.translationConfig,
    videoMessage: (state) => state.videoMessage,

    isShowErrorsView: (state) => state.isShowErrorsView,

    currentView: (state) => state.currentView.viewName,
    agentAutoMessage: (state) => state.agentAutoMessage,
    showVideoLoader: (state) => state.showVideoLoader,
    callOnHold: (state) => state.callOnHold,
    connectedToCallCenter: (state) => state.connectedToCallCenter,
    agentArrivedToVideo: (state) => state.agentArrivedToVideo,
    isTranslationOn: (state) => state.isTranslationOn,
    vidyoError: (state) => state.vidyoError,
    getWidgetHost(state) {
      // if configured "widgetHost" property at data.json take it from there,
      // otherwise - from the widgetHost which parsed at App.vue
      return state.appData.WidgetData.config.widgetHost &&
        state.appData.WidgetData.config.widgetHost !== ""
        ? state.appData.WidgetData.config.widgetHost
        : state.parsedWidgetHost;
    },
    IISAppName: (state) => state.IISAppName,
    msgTrDelimeter: (state) => "%@$%",
    isAgentAvailableCheckingConfigured(state) {
      if (!state.appData.WidgetData.queueChecks) {
        Utils.log.debug('No queue check');
        return false;
      }
      if (!state.appData.WidgetData.queueChecks.url || state.appData.WidgetData.queueChecks.url == '') {
        Utils.log.debug('No queue check URL to check for agents');
        return false;
      }
      if (!state.appData.JoinChatData || !state.appData.JoinChatData.Call_Center_QueueName || state.appData.JoinChatData.Call_Center_QueueName == '') {
        Utils.log.debug('No queue name to check for agents');
        return false;
      }
      if (state.appData.WidgetData.externalController != true && (!state.appData.WidgetData.queueChecks.noAgent_VideoUrl || state.appData.WidgetData.queueChecks.noAgent_VideoUrl == '')) {
        Utils.log.debug('No queue check video URL while waiting');
        return false;
      }
      Utils.log.debug('Agent availability configured');
      return true;
    },
    isAutoJoin: (state) => state.isAutoJoin,
    scEvents: (state) => state.scEvents,
    scAnswered: (state) => state.scAnswered,
    scEventId: (state) => state.scEventId,
    initialRoute: (state) => state.initialRoute,
    passedCallID: (state) => state.passedCallID,
    isSurveyOnly: (state) => state.isSurveyOnly,
    captchaConfig: (state) => state.captchaConfig,
    captchaToken: (state) => state.captchaToken,
    isCallbackPossibleDefault(state) {
      if (state.appData.DataGlobal.callbackSDK && state.appData.DataGlobal.callbackSDK != '' &&
      state.appData.WidgetData.enterChatView && state.userTenantID && state.userTenantID>= 0) {
        var strCallbackNumber = null;
        var enterChatViewCloned = JSON.parse(JSON.stringify(state.appData.WidgetData.enterChatView));
        enterChatViewCloned["fields"].forEach((it) => {
          if (it["isCallbackNumber"]) {
            strCallbackNumber = it.value;
          }
        });
        return strCallbackNumber != null;
      }
      return false;
    },
    isSCOverride: (state) => state.appData.SCOverride && state.appData.SCOverride.Enabled,
  }
});

export default store;